module.exports = __webpack_public_path__ + "static/media/shortHaulPlane1_big.67dfc5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Seats/img/shortHaulPlane1_big.jpg
// module id = 962
// module chunks = 0